<template>
  <Modal
      v-model="_value"
      width="500"
      title="批量设置车辆重点关注"
      @on-visible-change="visibleChange"
      ok-text="关闭"
      cancel-text="">
    <Form ref="batchAttentionForm" :model="batchAttention" style="display: inline;">
      <FormItem prop="content">
        <label style="display: inline-block; width: 60px;">离线通知间隔（单位小时）</label>
        <InputNumber style="display: inline-block; width: 200px;" v-model="batchAttention.timeSpan" placeholder="请输入笔记内容">
        </InputNumber>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <Button type="primary" @click="attentionAll" style="margin-right: 5px;">全部开启</Button>
      <Button type="primary" @click="disAttentionAll">全部关闭</Button>
    </Row>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'batchsetattentionmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        batchAttention: {
          vehicleInfoGroupId: null,
          val:false,
          timeSpan: 0
        }
      }
    },
    methods: {
      ...mapActions([
        'VehicleInfoServ_AttentionAll'
      ]),
      formatDate(val) {
        if (val) {
          let d = new Date(val)
          return d.Format('yyyy年MM月dd日 hh:mm:ss')
        } else {
          return '无'
        }
      },
      attentionAll(){
        this.batchAttention.val = true
        this.callApi()
      },
      disAttentionAll(){
        this.batchAttention.val = false
        this.callApi()
      },
      callApi(){
        store.dispatch('VehicleInfoServ_AttentionAll', {
          params: this.batchAttention
        }).then(() => {
          this.$Message.success('设置成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if (val) {
          this.batchAttention.vehicleInfoGroupId = this._initValue
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
